import React from 'react';
import { InformationContextValue } from './types';

// Some drawer entry points open information-request flows outside this provider.
// Defaults should no-op and resolve so callers do not hang on awaited context methods.
const InformationDashboard409AContext = React.createContext<InformationContextValue>({
  handleGetCurrentInformationRequests: () => Promise.resolve(),
  currentDocuments: undefined,
  addFilesToFolder: () => Promise.resolve(),
  refreshDocuments: () => null,
  downloadDocument: () => null,
  updateSubFolder: () => Promise.resolve(null),
  featuresObjects: {},
  permissions: {
    canUseInfoRequestLedger: false,
    canViewDocuments: false,
    canDownloadDocuments: false,
    canEditSetup: false,
    canSendInfoRequest: false,
    canCopyPortalLink: false,
  },
  updatePortalLinksAndTask: () => Promise.resolve(),
  is409a: false,
});

export default InformationDashboard409AContext;
